define([
	"dojo/_base/declare",
	"csi/heading/StringSelection",
	"csi/locale",
	"./ExportClassStore"
], function(declare,StringSelection,locale,ExportClassStore) {

	return declare(StringSelection, {
		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: return the localized type name
			return locale.type(value);
		},

		getStore: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*Boolean*/bAll) {
			// summary: create store for classes that have Export views
			return ExportClassStore;
		}
	});
});